import React, { useEffect, useState } from "react";
import { MdArrowDropDown } from "react-icons/md";
import { RiEyeCloseLine } from "react-icons/ri";
import { IoEye } from "react-icons/io5";
import Constant from "../Components/Utils/Constant";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import Sidebar from "../Components/Sidebar";

export default function UserEditform(subscriptionRes) {
  const navigate = useNavigate();
  const { user_id } = useParams();
  console.log("user_id", user_id);
  const userId = user_id;
  const [isVisible, setIsVisible] = useState(true);
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [newPassword, setPassword] = useState("");
  const [device, setDevice] = useState("");
  const [subscription, setSubscription] = useState("");
  const [date, setDate] = useState({
    day: "",
    month: "",
    year: "",
  });
  const [address, setAddress] = useState("");
  const [proffesion, setProffesion] = useState("");
  const [gst, setGst] = useState("");
  const [companyname, setCompanyname] = useState("");
  const [createdby, setCreatedby] = useState("");
  const [devicesID, setDevicesID] = useState("");
  const [totalCount, setTotalCount] = useState(null);
  const [totalPages, setTotalPages] = useState(1);
  const [userName, setUserName] = useState("");
  const [user, setUser] = useState([]);
  const [SelectedUser, setSelectedUser] = useState({});
  const [togglePassword, setTogglePassword] = useState(false);
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [isPhoneValid, setIsPhoneValid] = useState(true);
  const [isGstValid, setIsGstValid] = useState(true);
  const [openDropdown, setOpenDropdown] = useState(null); // Single state to manage dropdowns
  const [subscriptionChanged, setSubscriptionChanged] = useState(false);

  // Toggle dropdown
  const toggleDropdown = (dropdown) => {
    setOpenDropdown(openDropdown === dropdown ? null : dropdown);
  };

  const handleClose = () => {
    setIsVisible(false);
  };

  useEffect(() => {
    const storedName = localStorage.getItem("name");

    if (storedName) {
      setUserName(storedName);
      setCreatedby(storedName);
    } else {
      setUserName("Unauthorized");
      setCreatedby("Unauthorized");
    }
  }, []);

  useEffect(() => {
    if (user.length > 0) {
      getUserById(user_id);
    }
  }, [user]);

  useEffect(() => {
    setValue();
  }, [SelectedUser]);

  const setValue = () => {
    setName(SelectedUser.name);
    setEmail(SelectedUser.email);
    setPhone(SelectedUser.phone);
    setAddress(SelectedUser.address);
    setDevice(SelectedUser.device);
    setSubscription(SelectedUser.subscription);
    setCompanyname(SelectedUser.companyname);
    setPassword(SelectedUser.newPassword);
    setGst(SelectedUser.gst);
    setProffesion(SelectedUser.proffesion);
    setDate(SelectedUser.date);
    setSubscriptionChanged(false);
  };

  const getUserById = (id) => {
    setSelectedUser(
      user.find((item) => {
        return item._id == id;
      })
    );
  };
  // get api
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await fetch(`${Constant.BASE_URL}/user/get`);
        const data = await response.json();
        // setUser(data.admins);
        if (data && data.admins) {
          setUser(data.admins);
          if (data.success) {
            setTotalCount(data.totalCount);
            setTotalPages(data.totalPages);
          }
        }
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };
    fetchUser();
  }, []);

  // valiadations

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  const validatePhone = (phone) => {
    const phoneRegex = /^\d{10}$/;
    return phoneRegex.test(phone);
  };
  // const validateGst = (gst) => {
  //     // GST number regex (adjust as needed)
  //     const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[A-Z0-9]{1}$/;
  //     return gstRegex.test(gst);
  // };

  // update api
  const handleUpdate = async (e) => {
    e.preventDefault();
    // Validate email and phone
    const isEmailValid = validateEmail(email);
    const isPhoneValid = validatePhone(phone);
    // const isGstValid = validateGst(gst);
    setIsEmailValid(isEmailValid);
    setIsPhoneValid(isPhoneValid);
    // setIsGstValid(isGstValid);
    // If both email and phone are valid, proceed with form submission
    if (isEmailValid && isPhoneValid) {
      try {
        const userData = {
          email,
          name,
          phone,
          newPassword,
          device,
          date,
          address,
          proffesion,
          gst,
          companyname,
          createdby,
          devicesID,
        };

        if (subscriptionChanged) {
          userData.subscription = subscription;
        }

        const response = await axios.put(
          `${Constant.BASE_URL}/user/updatebyid`,
          userData
        );
        if (response.status === 200) {
          handleClose();
          setEmail("");
          setAddress("");
          setCompanyname("");
          setDate("");
          setName("");
          setSubscription("");
          setPassword("");
          setProffesion("");
          setPhone("");
          setGst("");
          setDevice("");
          // close the update form
          handleClose();
          // navigate to the main page
          navigate("/users");
          console.log("update sucessfully");
        } else {
          console.log("Update failed:", response.status);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };
  // handle time
  const handleDateChange = (field, value) => {
    setDate((prevDate) => {
      const updatedDate = { ...prevDate, [field]: value };
      const { day, month, year } = updatedDate;

      if (day && month && year) {
        const dateString = `${year}-${month}-${day},05:30:00`;
        const isoString = new Date(dateString).toLocaleString();
        console.log(isoString, "isoString");

        return isoString;
      }

      return updatedDate;
    });
  };

  return (
    <Sidebar>
      <>
        <div className="">
          {user.map((user) => (
            <div key={user._id}>
              {/* Edit form  */}

              <div className="flex justify-center ">
                <div className="absolute lg:top-[170px] xl:top-[200px] 2xl:top-[500px]  flex items-center justify-center z-10">
                  <div className="p-4 px-1 py-3 bg-white rounded-md lg:py-3 xl:py-3 2xl:p-4 ">
                    <div className="lg:w-[600px] xl:w-[630px] 2xl:w-[900px] items-center justify-center">
                      <div className="mb-4 text-lg font-semibold text-center 2xl:text-4xl ">
                        Edit User
                      </div>
                      <hr className="mt-1 " />

                      <form onSubmit={handleUpdate}>
                        <div className="flex items-center justify-center lg:py-1 xl:py-5 2xl:py-16 lg:text-[10px] xl:text-[13px] 2xl:text-[22px]">
                          <div className="pr-3 border-r ">
                            <div className="flex justify-end py-3">
                              <label
                                htmlFor="yourInput"
                                className="flex items-center px-3 "
                              >
                                Names :
                                <span className="ml-1 text-red-500">*</span>
                              </label>
                              <input
                                type="text"
                                id="yourInput"
                                className="border-b border-gray-500 outline-none createuserline"
                                placeholder="Name"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                required
                              />
                            </div>

                            <div className="flex justify-end py-3">
                              <label
                                htmlFor="yourInput"
                                className="flex items-center px-3 mb-1"
                              >
                                Phone :
                                <span className="ml-1 text-red-500">*</span>
                              </label>
                              <div className="flex flex-col">
                                <input
                                  type="text"
                                  id="phone"
                                  className="border-b border-gray-500 outline-none createuserline"
                                  value={phone}
                                  onChange={(e) => setPhone(e.target.value)}
                                  placeholder="Phone"
                                  required
                                />
                                {!isPhoneValid && (
                                  <p className="text-red-500">
                                    Invalid phone format (10 digits)
                                  </p>
                                )}
                              </div>
                            </div>
                            <div className="flex justify-end py-3">
                              <label
                                htmlFor="yourIn"
                                className="flex items-center px-3 mb-1"
                              >
                                Email :
                                <span className="ml-1 text-red-500">*</span>
                              </label>
                              <div className="flex flex-col">
                                <input
                                  type="email"
                                  id="yourIn"
                                  className="border-b border-gray-500 outline-none createuserline"
                                  placeholder="Email"
                                  value={email}
                                  onChange={(e) => setEmail(e.target.value)}
                                  required
                                />
                                {!isEmailValid && (
                                  <p className="ml-1 text-red-500">
                                    Invalid email format
                                  </p>
                                )}
                              </div>
                            </div>
                            <div className="flex justify-end py-3 relative">
                              <label
                                htmlFor="yourInput"
                                className="flex items-center px-3 mb-1 "
                              >
                                Password :
                                <span className="ml-1 text-red-500"></span>
                              </label>
                              <input
                                type={togglePassword ? "text" : "password"}
                                id="password"
                                className="relative border-b border-gray-500 outline-none createuserline"
                                placeholder="....."
                                value={newPassword}
                                onChange={(e) => setPassword(e.target.value)}
                              />
                              <span
                                onClick={() => {
                                  setTogglePassword(!togglePassword);
                                }}
                                className="absolute inset-y-0  flex items-center pr-2"
                              >
                                {togglePassword ? (
                                  <div className="">
                                    <IoEye className="text-1xl" />
                                  </div>
                                ) : (
                                  <div className="">
                                    <RiEyeCloseLine className="text-1xl" />
                                  </div>
                                )}
                              </span>
                            </div>
                            <div className="flex justify-end py-3">
                              <label
                                htmlFor="yourSelect"
                                className="flex items-center px-3 mb-1"
                              >
                                Device :
                                <span className="ml-1 text-red-500">*</span>
                              </label>
                              <div className="relative borderuser">
                                <select
                                  id="yourSelect"
                                  className="bg-white border-b border-gray-500 outline-none appearance-none createuserline"
                                  required
                                  value={device}
                                  onChange={(e) => setDevice(e.target.value)}
                                >
                                  <option value="" disabled selected>
                                    Select{" "}
                                  </option>
                                  <option value="option1">Android</option>
                                  <option value="option2">IOS</option>
                                </select>
                                <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                                  <div className="mb-2 bg-white border border-white shadow-md">
                                    <MdArrowDropDown className="text-1xl" />
                                  </div>
                                </span>
                              </div>
                            </div>

                            <div className="flex justify-end py-3">
                              <label
                                htmlFor="yourSelect"
                                className="flex items-center px-3 mb-1 "
                              >
                                Subscription :
                                <span className="ml-1 text-red-500">*</span>
                              </label>
                              <div className="relative">
                                <select
                                  id="yourSelect"
                                  className="border-b border-gray-500 outline-none appearance-none createuserline"
                                  value={subscription}
                                  onChange={(e) => {
                                    setSubscription(e.target.value);
                                    setSubscriptionChanged(true);
                                  }}
                                  required
                                >
                                  <option value="" disabled>
                                    Select
                                  </option>
                                  {subscriptionRes?.subscription?.map(
                                    (plan, index) => {
                                      if (
                                        plan.planevisibility &&
                                        plan.planevisibility.includes("Admin")
                                      ) {
                                        return (
                                          <option
                                            key={index}
                                            value={plan?.planevalidity}
                                          >
                                            Plan: {plan?.planname} (Validity:{" "}
                                            {plan?.planevalidity})
                                          </option>
                                        );
                                      } else {
                                        return "No Coupons Found";
                                      }
                                    }
                                  )}
                                </select>
                                <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                                  <div className="mb-2 bg-white border border-white shadow-md">
                                    <MdArrowDropDown className="text-1xl" />
                                  </div>
                                </span>
                              </div>
                            </div>
                          </div>

                          {/* Date started  */}

                          <div className="flex-col py-4 pl-1 pr-2 w-fit">
                            <div className="flex py-3 relative justify-end">
                              <label
                                htmlFor="yourDateInput"
                                className="mb-1 flex items-center px-3"
                              >
                                Date of Birth:
                                <span className="text-red-500 ml-1">*</span>
                              </label>
                              <div className="flex gap-5">
                                {/* Day Select */}
                                <div className="flex relative ">
                                  <input
                                    type="text"
                                    placeholder="DD"
                                    className="border-b border-gray-500 outline-none lg:w-[40px] 2xl:w-[110px]
                                                    xl:w-[40px] appearance-none outline-none lg:text-[10px] xl:text-[10px]  text-[#BBB] 2xl:text-2xl"
                                    onChange={(e) =>
                                      handleDateChange("day", e.target.value)
                                    }
                                    readOnly
                                    required
                                    value={new Date(date).getDate()}
                                  />
                                  <span className="absolute inset-y-0 right-0 flex items-center pl-2 ">
                                    <div className="bg-white shadow-md border border-white mb-1">
                                      <MdArrowDropDown
                                        onClick={() => toggleDropdown("day")}
                                        className="text-1xl"
                                      />
                                    </div>
                                  </span>
                                  {/* Dropdown Content */}
                                  {openDropdown === "day" && (
                                    <div
                                      style={{
                                        boxShadow:
                                          "0px 4px 8px 0px rgba(0, 0, 0, 0.25)",
                                        borderRadius: "0 0 5px 5px",
                                        zIndex: "100",
                                      }}
                                      className="lg:text-[10px] lg:w-[40px] xl:w-[40px] 2xl:w-[110px] xl:text-[15px] absolute top-6 left-25 xl:top-6 2xl:top-9 bg-white border border-white border-opacity-60 bg-white"
                                    >
                                      {/* Dropdown Options */}
                                      <ul className="text-center overflow-y-auto lg:h-[200px] xl:h-[200px] 2xl:h-[300px]  unitymodel">
                                        {Array.from({ length: 31 }, (_, i) => (
                                          <option key={i + 1} value={i + 1}>
                                            {i + 1}
                                          </option>
                                        ))}
                                      </ul>
                                    </div>
                                  )}
                                </div>
                                {/* Month Select */}
                                <div className="flex relative">
                                  <input
                                    id="monthSelect"
                                    type="text"
                                    placeholder="MM"
                                    className="border-b border-gray-500 outline-none lg:w-[40px] xl:w-[40px] 2xl:w-[110px] appearance-none outline-none lg:text-[10px] xl:text-[10px]  text-[#BBB] 2xl:text-2xl"
                                    onChange={(e) =>
                                      handleDateChange("month", e.target.value)
                                    }
                                    readOnly
                                    required
                                    value={
                                      Number(new Date(date).getMonth()) + 1
                                    }
                                  />
                                  <span className="absolute inset-y-0 right-0 flex items-center pl-2 ">
                                    <div className="bg-white shadow-md border border-white mb-1">
                                      <MdArrowDropDown
                                        onClick={() => toggleDropdown("month")}
                                        className="text-1xl"
                                      />
                                    </div>
                                  </span>
                                  {/* Dropdown Content */}
                                  {openDropdown === "month" && (
                                    <div
                                      style={{
                                        boxShadow:
                                          "0px 4px 8px 0px rgba(0, 0, 0, 0.25)",
                                        borderRadius: "0 0 5px 5px",
                                        zIndex: "100",
                                      }}
                                      className="lg:text-[10px] lg:w-[40px] xl:w-[40px] 2xl:w-[110px] xl:text-[15px] absolute top-6 left-25 xl:top-6 2xl:top-9 bg-white border border-white border-opacity-60 bg-white"
                                    >
                                      {/* Dropdown Options */}
                                      <ul className="text-center overflow-y-auto lg:h-[200px] xl:h-[200px] 2xl:h-[300px]  unitymodel">
                                        {/* Dropdown Options */}
                                        {Array.from({ length: 12 }, (_, i) => (
                                          <option key={i + 1} value={i + 1}>
                                            {i + 1}
                                          </option>
                                        ))}
                                      </ul>
                                    </div>
                                  )}
                                </div>

                                {/* Year Select */}

                                <div className="flex relative">
                                  <input
                                    id="yearSelect"
                                    type="text"
                                    placeholder=" YYYY"
                                    className="border-b border-gray-500 outline-none lg:w-[40px] xl:w-[40px] 2xl:w-[110px] appearance-none outline-none lg:text-[10px] xl:text-[10px]  text-[#BBB] 2xl:text-xl"
                                    onChange={(e) =>
                                      handleDateChange("year", e.target.value)
                                    }
                                    readOnly
                                    required
                                    value={new Date(date).getFullYear()}
                                  />
                                  <span className="absolute inset-y-0 right-0 flex items-center pl-2 ">
                                    <div className="bg-white shadow-md border border-white mb-1">
                                      <MdArrowDropDown
                                        onClick={() => toggleDropdown("year")}
                                        className="text-1xl"
                                      />
                                    </div>
                                  </span>
                                  {/* Dropdown Content */}
                                  {openDropdown === "year" && (
                                    <div
                                      style={{
                                        boxShadow:
                                          "0px 4px 8px 0px rgba(0, 0, 0, 0.25)",
                                        borderRadius: "0 0 5px 5px",
                                        zIndex: "100",
                                      }}
                                      className="lg:text-[10px] lg:w-[40px] xl:w-[40px] 2xl:w-[110px] xl:text-[15px] absolute top-6 left-25 xl:top-6 2xl:top-9 bg-white border border-white border-opacity-60 bg-white"
                                    >
                                      {/* Dropdown Options */}
                                      <ul className="text-center overflow-y-auto lg:h-[200px] xl:h-[200px] 2xl:h-[300px]  unitymodel">
                                        {Array.from({ length: 90 }, (_, i) => (
                                          <option
                                            key={1950 + i}
                                            value={1950 + i}
                                          >
                                            {1950 + i}
                                          </option>
                                        ))}
                                      </ul>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>

                            {/* Date ended  */}
                            <div className="flex justify-end py-3">
                              <label
                                htmlFor="yourInput"
                                className="flex items-center px-3 mb-1"
                              >
                                Address :
                                <span className="ml-1 text-red-500">*</span>
                              </label>
                              <input
                                type="text"
                                id="yourInput"
                                className="border-b border-gray-500 outline-none createuserline"
                                value={address}
                                onChange={(e) => setAddress(e.target.value)}
                                placeholder="Text"
                                required
                              />
                            </div>

                            <div className="flex justify-end py-3">
                              <label
                                htmlFor="yourSelect"
                                className="flex items-center px-3 mb-1 "
                              >
                                Profession :
                                <span className="ml-1 text-red-500">*</span>
                              </label>
                              <div className="relative text-center">
                                <select
                                  id="yourSelect"
                                  className="border-b border-gray-500 outline-none appearance-none createuserline"
                                  style={{ color: "#BBB " }}
                                  value={proffesion}
                                  onChange={(e) =>
                                    setProffesion(e.target.value)
                                  }
                                  required
                                >
                                  <option value="" disabled selected>
                                    Text{" "}
                                  </option>
                                  <option value="Fabric Manufacturer">
                                    Fabric Manufacturer
                                  </option>
                                  <option value="Garment Manufacturer">
                                    Garment Manufacturer
                                  </option>
                                  <option value="Yarn Manufacturer">
                                    Yarn Manufacturer
                                  </option>
                                  <option value="Trader & Broker">
                                    Trader & Broker
                                  </option>
                                  <option value="Buyer">Buyer</option>
                                  <option value="Designer">Designer</option>
                                  <option value="Finisher">Finisher</option>
                                  <option value="Other">Other</option>
                                </select>
                                <span className="absolute inset-y-0 right-0 flex items-center pointer-events-none">
                                  <div className="mb-2 bg-white border border-white shadow-md">
                                    <MdArrowDropDown className="text-1xl" />
                                  </div>
                                </span>
                              </div>
                            </div>
                            <div className="flex justify-end py-3">
                              <label
                                htmlFor="yourInput"
                                className="flex items-center px-3 mb-1"
                              >
                                GST Number :
                              </label>
                              <div className="flex flex-col">
                                <input
                                  type="text"
                                  id="gst"
                                  className={`border-b border-gray-500 outline-none createuserline "
                                                                        }`}
                                  value={gst}
                                  onChange={(e) => setGst(e.target.value)}
                                  placeholder="gstnumber"
                                />
                              </div>
                            </div>
                            <div className="flex justify-end py-3">
                              <label
                                htmlFor="yourInput"
                                className="flex items-center px-3 mb-1"
                              >
                                Company Name :
                                <span className="text-red-500 ">*</span>
                              </label>
                              <input
                                type="text"
                                id="yourInput"
                                className="border-b border-gray-500 outline-none createuserline"
                                value={companyname}
                                onChange={(e) =>
                                  setCompanyname(e.target.value)
                                }
                                placeholder="Text"
                                required
                              />
                            </div>
                            <div className="flex justify-end py-3">
                              <label
                                htmlFor="yourInput"
                                className="flex items-center px-3 mb-1"
                              >
                                Created By :
                                <span className="ml-1 text-red-500">*</span>
                              </label>
                              <input
                                type="text"
                                id="yourInput"
                                className="border-b border-gray-500 outline-none createuserline"
                                value={userName}
                                onChange={(e) => setCreatedby(e.target.value)}
                                placeholder="Super Admin (Login Detect)"
                                required
                              />
                            </div>
                          </div>
                        </div>
                        <div
                          className="button-container flex justify-center p-1 space-x-12 lg:pb-5 xl:pb-5 2xl:pb-5 
                                        lg:text-[10px] xl:text-[13px] 2xl:text-[22px]"
                        >
                          <Link to="/users">
                            <button
                              type="button"
                              onClick={handleClose}
                              className="flex-shrink-0 px-3 py-1 bg-white shadow-md "
                              style={{
                                boxShadow:
                                  "0px 4px 8px 0px rgba(0, 0, 0, 0.25)",
                              }}
                            >
                              Cancel
                            </button>
                          </Link>
                          <button
                            type="submit"
                            className="flex-shrink-0 px-3 py-1 "
                            style={{
                              background:
                                "radial-gradient(125% 125% at 85.42% 0%, #FFD6A6 0%, #FF9C28 100%)",
                            }}
                          >
                            Update
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </>
    </Sidebar>
  );
}